import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/tools',
    component: HeaderAsideLayout,
    children: [
      { path: '/tools/job/index', component: () => import('@/pages/tools/job/index.vue') },
      { path: '/tools/job/add', component: () => import('@/pages/tools/job/add.vue') },
    ],
  },
]
export default list